module.exports = __webpack_public_path__ + "img/kefu.7b90bc38.png";